// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/KioskApp/layout.scss
// module id = 102
// module chunks = 0